<template>
  <!-- pro-list .pl -->
  <div class="pl">
    <filterCommon2></filterCommon2>
    <proItem></proItem>
  </div>
</template>

<script>
import filterCommon2 from "@components/filter-common2/filter-common2.vue";
import proItem from "./components/pro-item.vue";
export default {
  name: "pro-list",
  data() {
    return {};
  },
  components: { filterCommon2, proItem },
  computed: {},
  methods: {}
};
</script>

<style scoped lang="scss">
.pl {
  
}
</style>
